/**
 * @enum {enumAuthenticationStatus} Represents status modes for authentication
 */
export enum enumAuthenticationStatus {
  None = 'None',  // authentication status hasn't been determined
  AnonymousUser = 'AnonymousUser',  // the user isn't logged in
  AuthenticationInProgress = 'AuthenticationInProgress',  // a user has logged in and the authentication process is in progress
  AuthenticationComplete = 'AuthenticationComplete'  // the authentication process has completed
}